import React, { Component } from "react";
import { matchPath, withRouter } from "react-router";
import DropdownMenu from "components/dropdownMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactCountryFlag from "react-country-flag";
import { connect } from "react-redux";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import { setLanguage } from "reducers/i18n";
import settings from "client.settings.json";
import { translate } from "reducers/i18n";
import "./languageSelector.css";

const stem = settings.frontend_app_path;

class languageSelector extends Component {
  state = {};

  render() {
    const { history, location, username, authenticatorSource } = this.props;
    const { params = {} } = matchPath(location.pathname, { path: `${stem}:tenantId/:page/:messageId` }) || {};
    const { tenantId, messageId } = params;

    const languageLabels = [
      { value: "nl", flag: "nl", label: "Netherlands" },
      { value: "en", flag: "gb", label: "English" }
    ];

    return (
      <div className="languageSelector">
        <DropdownMenu
          dropdownClassName="dropdown-container"
          buttonChildren={
            <>
              <ReactCountryFlag
                className="mr-2"
                countryCode={languageLabels.find(language => language.value === this.props.i18n.language)?.flag}
                svg
              />
              {username ? (
                <span className="text-uppercase username">{username}</span>
              ) : (
                <p className="language-text">
                  {translate(languageLabels.find(language => language.value === this.props.i18n.language)?.label)}
                </p>
              )}
            </>
          }
          closeOnClick
        >
          {Object.keys(this.props.i18n.availableLanguages).map(lang => (
            <li
              key={lang}
              className="dropdownMenu-list"
              value={lang}
              onClick={() => void this.props.dispatch(setLanguage(lang))}
            >
              <ReactCountryFlag countryCode={languageLabels.find(language => language.value === lang)?.flag} svg />{" "}
              {translate(languageLabels.find(language => language.value === lang)?.label)}
            </li>
          ))}
          {username && authenticatorSource !== "breakTheGlass" ? (
            <>
              <div className="dropdown-divider" />
              <li
                className="dropdownMenu-list"
                onClick={() => history.push(`${stem}${tenantId}/authenticators/${messageId}`)}
              >
                <FontAwesomeIcon icon={faMobileAlt} className="mr-2" />
                {translate("login_methods")}
              </li>
            </>
          ) : null}
        </DropdownMenu>
      </div>
    );
  }
}

const mapStateToProps = state => ({ i18n: state.i18n, username: state.user.username, authenticatorSource: state.user.authenticatorSource });

export default withRouter(connect(mapStateToProps)(languageSelector));
